// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-loading {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
  color: var(--g-color-text-complementary);
  background-color: var(--g-color-base-background);
}
.export-loading::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
  background-color: var(--dl-color-export-loading-toast);
}
.export-loading__content {
  margin-top: 2px;
  padding-left: 8px;
}
.export-loading__success-icon {
  display: flex;
  width: 25px;
  justify-content: center;
  color: var(--g-color-text-positive);
}
.export-loading__text {
  display: inline;
}
.export-loading_success::before {
  background-color: var(--g-color-base-positive-light);
}
.export-loading_reference {
  width: 312px;
  visibility: hidden;
  opacity: 0;
  position: absolute;
  right: 0;
  bottom: 0;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/ChartKitBase/components/Header/components/Menu/Items/Export/ToastContent/ToastContent.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;EC4KI,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;ED7KA,wCAAA;EACA,gDAAA;AAEJ;AAAI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,sDAAA;AAER;AACI;EACI,eAAA;EACA,iBAAA;AACR;AAEI;EACI,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mCAAA;AAAR;AAGI;EACI,eAAA;AADR;AAII;EACI,oDAAA;AAFR;AAKI;EACI,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AAHR","sourcesContent":[".export-loading {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n  color: var(--g-color-text-complementary);\n  background-color: var(--g-color-base-background);\n}\n.export-loading::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: -1;\n  background-color: var(--dl-color-export-loading-toast);\n}\n.export-loading__content {\n  margin-top: 2px;\n  padding-left: 8px;\n}\n.export-loading__success-icon {\n  display: flex;\n  width: 25px;\n  justify-content: center;\n  color: var(--g-color-text-positive);\n}\n.export-loading__text {\n  display: inline;\n}\n.export-loading_success::before {\n  background-color: var(--g-color-base-positive-light);\n}\n.export-loading_reference {\n  width: 312px;\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  white-space: nowrap;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
